import { MenuListItemProps } from "../types";
import CtaContent from "components/CtaContent";
import React from "react";
import cn from "classnames";
import dictionary from "configs/dictionary";

const MenuListItem = ({ data }: MenuListItemProps) => {
  const { pageReference } = data;
  // TODO: create a type on dictionary
  const ComponentLink =
    dictionary.ContentfulCtaReferenceV2 as React.ElementType;

  const accessibility = {
    accessibility: {
      tabindex: "-1",
      role: "menuitem",
    },
  };

  const pageReferenceProps = { ...pageReference, ...accessibility };

  const itemClass = cn("menuItem__link");

  return (
    <ComponentLink {...pageReferenceProps} className={itemClass}>
      <CtaContent {...pageReference.content[0]} />
    </ComponentLink>
  );
};

export default MenuListItem;
